<script setup>
import Card from '@/Components/Card/Card.vue';
import { inject } from 'vue';
import ACTION_TYPES from '@/Common/Enum/ActionType.js';
import LinkDomainAnalysis from '@/Pages/DomainScore/Partials/DetailedReport/LinkDomainAnalysis.vue';
import ExplainScorePart from '@/Pages/DomainScore/Partials/DetailedReport/ExplainScorePart.vue';
import DetailedReportHeader from '@/Pages/DomainScore/Partials/DetailedReport/DetailedReportHeader.vue';
import { getTlsDnsRecordStatus } from '@/Common/DnsRecordMessaging.js';
import ContactUsForAssistance from '@/Pages/DomainScore/Partials/ContactUsForAssistance.vue';

const result = inject('score');

const tlsRecordStatus = getTlsDnsRecordStatus(result);
</script>

<template>
  <Card class="bg-white-opacity">
    <DetailedReportHeader
      :title="
        $t(
          'domain_score.partials.detailed_report.privacy.tls_card.tlsrpt_or_smtp_tls'
        )
      "
      :description="
        $t('domain_score.partials.detailed_report.privacy.tls_card.description')
      "
      :tooltip="
        $t('domain_score.partials.detailed_report.privacy.tls_card.tooltip')
      "
    />
    <div class="mt-5 flex flex-col">
      <ExplainScorePart
        :title="
          $t(
            'domain_score.partials.detailed_report.privacy.tls_card.dns_record'
          )
        "
        :action-type="tlsRecordStatus.actionType"
      >
        {{ tlsRecordStatus.message }}
        <div v-if="tlsRecordStatus.canAnalyse">
          &nbsp;-
          <LinkDomainAnalysis :domain="result.domain" fragment="tls" />
        </div>
      </ExplainScorePart>

      <div>
        <ExplainScorePart
          v-if="result.records.tlsrpt.tlsrpt_providers.length"
          :title="
            $t(
              'domain_score.partials.detailed_report.privacy.tls_card.providers'
            )
          "
          :action-type="ACTION_TYPES.INFO"
        >
          {{ result.records.tlsrpt.tlsrpt_providers.join(', ') }}
        </ExplainScorePart>
        <ExplainScorePart
          v-else
          :title="
            $t(
              'domain_score.partials.detailed_report.privacy.tls_card.providers'
            )
          "
          :action-type="ACTION_TYPES.INFO"
        >
          <ContactUsForAssistance />
        </ExplainScorePart>
      </div>
    </div>
  </Card>
</template>
